//@flow
import React from 'react';
import { translate } from 'react-i18next';
import TeamHomebaseSelectorModal from 'common/entity/generic/TeamHomebaseSelectorModal';
import type { TFunction } from 'react-i18next';

type Props = {
    theme: Object,
    onCreate: ({
        clientId: string,
        homebaseId: ?string,
        teamId: ?string
    }) => void,
    onCancel: () => void,
    defaultHomebaseId?: string,
    defaultTeamId?: string,
    t: TFunction
};

class AddZoneMapModal extends React.PureComponent<Props> {
    render() {
        const {
            theme,
            onCancel,
            onCreate,
            t,
            defaultHomebaseId,
            defaultTeamId
        } = this.props;

        return (
            <TeamHomebaseSelectorModal
                theme={theme}
                onCreate={onCreate}
                onCancel={onCancel}
                defaultHomebaseId={defaultHomebaseId}
                defaultTeamId={defaultTeamId}
                title={t('zoneMap.createMap')}
                acceptActionLabel={t('zoneMap.create')}
                subtitle={t('zoneMap.selectTeamAndHomebase')}
            />
        );
    }
}

export default translate('entityManagement')(AddZoneMapModal);
